import type { Authority } from '@features/documents/api/types/document.types';

import { MAX_NOTES_LENGTH } from '@features/documents/utils/documentConstants';

import type { SubmitFormState } from './SubmitDocumentPanel.types';

export const INITIAL_FORM_STATE: SubmitFormState = {
  authority: '',
  file: null,
  notes: '',
};

export function isFormValid(state: SubmitFormState): boolean {
  return (
    state.authority !== '' && state.file !== null && state.notes.trim() !== ''
  );
}

export function isFormDirty(state: SubmitFormState): boolean {
  return state.authority !== '' || state.file !== null || state.notes !== '';
}

export function getNotesCharCount(notes: string): string {
  return `${notes.length}/${MAX_NOTES_LENGTH}`;
}

export const AUTHORITY_OPTIONS: { value: Authority; label: string }[] = [
  { value: 'FAA', label: 'FAA' },
  { value: 'EASA', label: 'EASA' },
  { value: 'OtherNAA', label: 'Other NAA' },
];
